import { Card, CardContent } from '@design-system/Card';
import { List, ListItem } from '@design-system/List';

const SUBSCRIPTION_FAQS_URL =
  'https://support.viome.com/en_us/categories/subscription-management-ry8EkrcjK';

export const SMPLandingPageInfo = () => {
  return (
    <div className="flex flex-col gap-6 pb-12" data-testid="smp-info-section">
      <h2
        className="typography-h2 text-primary px-1"
        data-testid="smp-info-title"
      >
        Information
      </h2>

      <Card data-testid="smp-info-card">
        <CardContent className="p-0" data-testid="smp-info-content">
          <List data-testid="smp-info-list">
            <ListItem data-testid="smp-info-faqs">
              <a
                href={SUBSCRIPTION_FAQS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="h-12 flex flex-row justify-start items-center w-full typography-btn-large text-primary"
              >
                Subscription FAQs
              </a>
            </ListItem>
          </List>
        </CardContent>
      </Card>
    </div>
  );
};
